var __WEBPACK_NAMESPACE_OBJECT__ = {
  "mode": "compressed",
  "staticDomainPrefix": "//static.hsappstatic.net",
  "bender": {
    "depVersions": {
      "ui-images": "static-2.1140"
    },
    "depPathPrefixes": {
      "ui-images": "/ui-images/static-2.1140"
    },
    "bundlingPackage": "customer-portal-app",
    "bundlingPackageVersion": "static-1.2141",
    "project": "ui-images",
    "staticDomain": "//static.hsappstatic.net",
    "staticDomainPrefix": "//static.hsappstatic.net"
  }
};